import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { environment } from '@environments/environment';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'lib-dialog-document-info',
    templateUrl: './dialog-document-info.component.html',
    standalone: false
})
export class DialogDocumentInfoComponent implements OnInit {
  public isMobile: boolean;
  public currentLang: string;
  public docInfo: any = {
    Name: '',
    Size: '',
    Title: '',
    Author: '',
    Creator: '',
    CreationDate: '',
    ModDate: '',
    Producer: '',
    PDFFormatVersion: '',
    Language: '',
    IsSignaturesPresent: false,
  };

  constructor(
    public dialogRef: MatDialogRef<DialogDocumentInfoComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private _translate: TranslateService) {
      this.isMobile = environment.platform === 'mobile';
    }

  ngOnInit(): void {
    this.currentLang = this._translate.currentLang;
    this.docInfo = this.data.docInfo;
  }
}
